import { GameScene } from '..';
import { IGameComponent } from './GameComponent';
import { EGameComponentHooks } from './GameComponentHooks';

export class GameComponentRegistry {
    private static readonly registry = new WeakMap<GameScene, IGameComponent[]>();

    static register(scene: GameScene, component: IGameComponent): void {
        if (!this.registry.has(scene)) {
            this.registry.set(scene, []);
        }
        this.registry.get(scene)!.push(component);
    }

    static callHook(scene: GameScene, hook: EGameComponentHooks): void {
        const components = this.registry.get(scene) || [];
        for (const component of components) {
            const fn = component[hook];
            if (typeof fn === 'function') {
                fn.call(component);
            }
        }
    }

    static clear(scene: GameScene): void {
        this.registry.delete(scene);
    }
}
